import { render } from "./XMultipleSelectOption.vue?vue&type=template&id=52c410d4&scoped=true"
import script from "./XMultipleSelectOption.vue?vue&type=script&lang=js"
export * from "./XMultipleSelectOption.vue?vue&type=script&lang=js"

import "./XMultipleSelectOption.vue?vue&type=style&index=0&id=52c410d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c410d4"]])

export default __exports__